import PurchasingASingleApartment from '@/assets/images/purchasingASingleApartment.svg?react'; // eslint-disable-line import/no-unresolved
import PurchasingAnAlternativeApartment from '@/assets/images/purchasingAnAlternativeApartment.svg?react'; // eslint-disable-line import/no-unresolved
import BusinessCredit from '@/assets/images/businessCredit.svg?react'; // eslint-disable-line import/no-unresolved
import AnyPurposeInMortgageOfProperty from '@/assets/images/anyPurposeInMortgageOfProperty.svg?react'; // eslint-disable-line import/no-unresolved
import MortgageRecycle from '@/assets/images/mortgateRecycle.svg?react'; // eslint-disable-line import/no-unresolved
import ReverseMortgage from '@/assets/images/reverseMortgage.svg?react'; // eslint-disable-line import/no-unresolved
import ApartmentForInvestment from '@/assets/images/apartmentForInvestment.svg?react'; // eslint-disable-line import/no-unresolved
import RenovationOrExpansion from '@/assets/images/renovationOrExpansion.svg?react'; // eslint-disable-line import/no-unresolved

export const PROPERTYLIST = Object.freeze([
  {
    value: 'singleProperty',
    icon: <PurchasingASingleApartment />,
  },
  {
    value: 'replacementProperty',
    icon: <PurchasingAnAlternativeApartment />,
  },
  {
    value: 'investmentProperty',
    icon: <ApartmentForInvestment />,
  },
  {
    value: 'renovationOrExpansion',
    icon: <RenovationOrExpansion />,
  },
  {
    value: 'anyPurposeWithPropertyCollateral',
    icon: <AnyPurposeInMortgageOfProperty />,
  },
  {
    value: 'mortgageRefinancing',
    icon: <MortgageRecycle />,
  },
  {
    value: 'anyPurposeWithPropertyCollateral',
    icon: <AnyPurposeInMortgageOfProperty />,
  },
  {
    value: 'reverseMortgage',
    icon: <ReverseMortgage />,
  },
  {
    value: 'businessCredit',
    icon: <BusinessCredit />,
  },
]);

export const WHITE_LIST_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
export const SPLIT_CHAR = '.';
export const MAX_BORROWERS = 3;

export const YESNO = Object.freeze({
  YES: 'yes',
  NO: 'no',
});

export const ROUTE_TYPES = Object.freeze({
  short: 'short',
  extended: 'extended',
});

export const CLIENT_SIGN_TYPES = Object.freeze({
  sign: 'sign',
  payment: 'payment',
});

export const MORTGAGE_CYCLE_ACTIONS = Object.freeze({
  reducingTheLoanPeriod: 'reducingTheLoanPeriod',
  reductionRepaymentWithoutChangingTheTermByConsolidatingLoans: 'reductionRepaymentWithoutChangingTheTermByConsolidatingLoans',
  reductionOfRepaymentAndExtensionOfTheLoanTermThroughLoanConsolidation: 'reductionOfRepaymentAndExtensionOfTheLoanTermThroughLoanConsolidation',
});

export const REVERSE_MORTGAGE_ACTIONS = Object.freeze({
  interestPaymentOnly: 'interestPaymentOnly',
  paymentOfPrincipalAndInterest: 'paymentOfPrincipalAndInterest',
  paymentAtTheEndOfThePeriod: 'paymentAtTheEndOfThePeriod',
});
